module.exports = __webpack_public_path__ + "media/assets/images/blog/laptop_doc-86df85e5232ac3053e067bd49f2be8e3.png";